// Fixed-decimal number with thousands separators: withCommas(5404.31, 1) -> "5,404.3".
export function withCommas(value, digits = 1) {
  return value.toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
